import React, { useEffect } from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import cn from "classnames";
import { Button } from "../../../components/Button";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { Input } from "../../../components/Input";
import { InputSelect } from "../../../components/InputSelect";
import { useContractors } from "../../../contexts/ContractorsContext";

type Props = {
  className?: string;
  onApply: (params: StatisticsAlbumsFiltersParams) => Promise<any>;
};

export type StatisticsAlbumsFiltersParams = {
  filter_artist: string;
  album_title: string;
  filter_external_id: string;
  filter_upc: string;
  limit?: number;
  offset?: number;
  page_number?: number;
};
export const StatisticsAlbumFilters: React.FC<Props> = ({
  className,
  onApply,
}) => {
  const { t } = useTranslation();
  const { contractors } = useContractors();
  const [query, setQuery] = useQueryParams({
    filter_artist: withDefault(StringParam, ""),
    album_title: withDefault(StringParam, ""),
    filter_external_id: withDefault(StringParam, ""),
    filter_upc: withDefault(StringParam, ""),
    contractor_id: withDefault(NumberParam, null),
  });

  useEffect(() => {
    onApply(query as StatisticsAlbumsFiltersParams).then();
  }, []);

  useEffect(() => {
    document.onkeyup = function (e) {
      if (e.key === "Enter") {
        void onApply(query as StatisticsAlbumsFiltersParams);
      }
    };

    return () => {
      document.onkeyup = null;
    };
  }, [query]);

  return (
    <div className={className}>
      <div className={cn("flex gap-2")}>
        {contractors.length > 1 && (
          <InputSelect
            isClearable
            placeholder={t("contractor").toString()}
            value={query.contractor_id}
            options={contractors.map((c) => {
              return {
                value: c.id,
                label: c.title,
              };
            })}
            onChange={(v) => setQuery({ contractor_id: v?.value as number })}
          />
        )}
        <Input
          value={query.filter_artist}
          placeholder={t("artist").toString()}
          onChange={(v) => setQuery({ filter_artist: v })}
        />
        <Input
          value={query.album_title}
          placeholder={t("album").toString()}
          onChange={(v) => setQuery({ album_title: v })}
        />
        <Input
          value={query.filter_upc}
          placeholder={"UPC"}
          onChange={(v) => setQuery({ filter_upc: v })}
        />
        <Input
          value={query.filter_external_id}
          placeholder={"External ID"}
          onChange={(v) => setQuery({ filter_external_id: v })}
        />
        <Button
          icon={faSearch}
          label={`${t("search")}`}
          onClick={() => onApply(query as any)}
        />
      </div>
    </div>
  );
};
